import { SQLService } from '../../../services/sql.service';
import { PopoverController } from '@ionic/angular';
import { Component } from '@angular/core';
@Component({
  selector: 'ng-cheques-payment-entry-popover',
  templateUrl: './payment-entry-menu.component.html',
  styleUrls: ['./payment-entry-menu.component.styl']
})
export class PaymentEntryMenuComponent {
  constructor(
    public sql: SQLService,
    public popover: PopoverController) {
  }
  dismissPopover(e) {if (this.popover) this.popover.dismiss(e);}
  delete() {this.dismissPopover('delete');}
  print() {this.dismissPopover('print');}
}